export enum BannerState {
  none,
  default,
  info,
  important
}
